// Project Lock Types
export const LOCK_TYPES = {
  SESSION: 'session',
  STATE_ALLOCATION: 'stateAllocation',
  CLEARANCE: 'clearance',
  // Project-level lock types
  SESSION_PROJECT: 'sessionProject',
  STATE_ALLOCATION_PROJECT: 'stateAllocationProject',
  CLEARANCE_PROJECT: 'clearanceProject'
};

// Lock Messages
export const LOCK_MESSAGES = {
  // Legacy table-level messages
  LOCKED_EDIT_WARNING: 'This table is locked. You cannot add, edit, or delete projects.',
  LOCK_CONFIRM: 'Are you sure you want to lock this table?',
  UNLOCK_CONFIRM: 'Are you sure you want to unlock this table?',
  LOCK_SUCCESS: 'Table locked successfully.',
  UNLOCK_SUCCESS: 'Table unlocked successfully.',
  LOCK_REQUIRED: 'Please select a financial year to view lock status.',
  NO_PERMISSION: 'Only administrators can lock/unlock tables.',
  
  // Project data lock messages (SessionBudgetDescriptive)
  PROJECT_LOCKED_EDIT_WARNING: 'This project is locked. You cannot edit or delete it.',
  PROJECT_LOCK_CONFIRM: 'Are you sure you want to lock this project? You will not be able to edit it until an admin unlocks it.',
  PROJECT_UNLOCK_CONFIRM: 'Are you sure you want to unlock this project?',
  PROJECT_LOCK_SUCCESS: 'Project locked successfully.',
  PROJECT_UNLOCK_SUCCESS: 'Project unlocked successfully.',
  PROJECT_LOCK_NO_PERMISSION: 'Only administrators can unlock projects.',
  PROJECT_ALREADY_LOCKED: 'This project is already locked.',
  PROJECT_NOT_LOCKED: 'This project is not locked.',
  
  // Clearance data lock messages (ClearanceProjectWise)
  CLEARANCE_LOCKED_EDIT_WARNING: 'Clearance data for this project is locked. You cannot edit it.',
  CLEARANCE_LOCK_CONFIRM: 'Are you sure you want to lock clearance data for this project? You will not be able to edit it until an admin unlocks it.',
  CLEARANCE_UNLOCK_CONFIRM: 'Are you sure you want to unlock clearance data for this project?',
  CLEARANCE_LOCK_SUCCESS: 'Clearance data locked successfully.',
  CLEARANCE_UNLOCK_SUCCESS: 'Clearance data unlocked successfully.',
  CLEARANCE_LOCK_NO_PERMISSION: 'Only administrators can unlock clearance data.',
  CLEARANCE_ALREADY_LOCKED: 'Clearance data for this project is already locked.',
  CLEARANCE_NOT_LOCKED: 'Clearance data for this project is not locked.'
};

// Lock Status Display
export const LOCK_STATUS = {
  LOCKED: {
    label: 'Locked',
    color: 'green',
    icon: 'lock-closed'
  },
  UNLOCKED: {
    label: 'Unlocked',
    color: 'blue',
    icon: 'lock-open'
  }
};

// Default Lock State (for table-level locks)
export const DEFAULT_LOCK_STATE = {
  isLocked: false,
  lockedAt: null,
  lockedBy: null,
  lockedByName: null,
  unlockedAt: null,
  unlockedBy: null,
  unlockedByName: null
};

// Default Project Lock State (for project-level locks)
export const DEFAULT_PROJECT_LOCK_STATE = {
  isLocked: false,
  lockedAt: null,
  lockedBy: null,
  lockedByName: null
};